import { Link } from 'react-router-dom';
import AppIcon from '../../images/app_icon.svg';

const Topbar = () => {

  return (
    <div className='header-wrapper'>
        <div className="public_topbar d-flex align-items-center justify-content-center">
            <Link to="/">
                <img src={AppIcon} loading='lazy' className='mb-0'/>
            </Link>
        </div>
    </div>

  );
};

export default Topbar;
